export enum CLAIM_INFORMATION_CONSTANTS {
  FORM_NAME = "ClaimInformation",
  FORM_HEADER = "Claim Information",
  FORM_DESCRIPTION = "Enter claim and customer information",

  DATE_OF_LOSS = "dateOfLoss",
  CUSTOMER_FIRST_NAME = "customerFirstName",
  CUSTOMER_LAST_NAME = "customerLastName",
  IS_INSURER_OR_REPRESENTATIVE_APPLICABLE = "isInsurerOrRepresentativeApplicable",
  INSURER_OR_REPRESENTATIVE_NAME = "insurerOrRepresentativeName",

  CUSTOMER_ADDRESS = "customerAddress",
  ADDRESS_LINE_1 = "addressLine1",
  ADDRESS_LINE_2 = "addressLine2",
  CITY = "city",
  COUNTRY = "country",

  CUSTOMER_EMAIL = "customerEmail",
  CUSTOMER_PHONE = "customerPhone",
  INCIDENT_TYPE = "incidentType",
  DESCRIPTION_OF_INCIDENT = "descriptionOfIncident",
  COUNTRY_WHERE_INCIDENT_OCCURRED = "countryWhereIncidentOccurred",
  PRODUCT_PURCHASE_DATE = "productPurchaseDate",
}

export const CLAIM_INFORMATION_FORM_NAME_TO_HEADER = {
  [CLAIM_INFORMATION_CONSTANTS.FORM_NAME]:
    CLAIM_INFORMATION_CONSTANTS.FORM_HEADER,
};

export enum PRODUCT_INFORMATION_CONSTANTS {
  FORM_NAME = "ProductInformation",
  FORM_HEADER = "Product Information",
  FORM_DESCRIPTION = "Enter product information details",

  COUNTRY_WHERE_ITEM_WAS_PURCHASED = "countryWhereItemWasPurchased",
  ORDER_ID = "orderId",
  ASIN = "asin",
  PRODUCT_NAME = "productName",
  FULFILMENT_PATH = "fulfilmentPath",
}

export const PRODUCT_INFORMATION_FORM_NAME_TO_HEADER = {
  [PRODUCT_INFORMATION_CONSTANTS.FORM_NAME]:
    PRODUCT_INFORMATION_CONSTANTS.FORM_HEADER,
};
export enum CLAIM_VALIDATION_CONSTANTS {
  FORM_NAME = "ClaimValidation",
  FORM_HEADER = "Claim Validation",
  FORM_DESCRIPTION = "Enter claim validation details",

  ALL_CLAIM_VALIDATION_FIELDS = "allClaimValidationFields",
  PRODUCT_CAUSED_INJURIES_OR_DAMAGES = "productCausedInjuriesOrDamages",
  REQUESTING_ITEM_REMOVAL = "requestingItemRemoval",
  SHARING_NEGATIVE_FEEDBACK = "sharingNegativeFeedback",
  REFUND_REQUEST_ONLY = "refundRequestOnly",
  SEEKING_ADDITIONAL_COMPENSATION = "seekingAdditionalCompensation",
  DELIVERY_ISSUE_RELATED = "deliveryIssueRelated",
}

export const CLAIM_VALIDATION_FORM_NAME_TO_HEADER = {
  [CLAIM_VALIDATION_CONSTANTS.FORM_NAME]:
    CLAIM_VALIDATION_CONSTANTS.FORM_HEADER,
};

export enum ADDITIONAL_INFORMATION_CONSTANTS {
  FORM_NAME = "AdditionalInformation",
  FORM_HEADER = "Additional Information",
  FORM_DESCRIPTION = "Enter additionalinformation details",

  INSTALLATION_SOURCE = "ifTheItemWasInstalledWasItByAmazonOrAThirdParty",
  PRODUCT_LINK = "productListingLink",
  ERC_OFFER_AMOUNT = "amountOfferedByErcToTheCustomer",
  ITEM_RETURNED = "wasItemReturnedToAmazon",
  AMAZON_LOCATION = "amazonLocationExSea41",
  RETURN_CENTER_POC = "sitePocForTheAmazonReturnCenterNameAndAmazonAlias",
  ADVISED_DISPOSAL = "didAmazonAdviseToDisposeOfTheProduct",
  SELLER_CONTACT_DETAILS = "sellerContactDetails",
  ADDRESS_LINE_1 = "addressLine1",
  ADDRESS_LINE_2 = "addressLine2",
  CITY = "city",
  COUNTRY = "country",
  PHONE = "phone",
  EMAIL = "email",
  REPORTED_TO_PR = "hasThisClaimBeenReportedToAmazonPublicRelationsPr",
}

export const ADDITIONAL_INFORMATION_FORM_NAME_TO_HEADER = {
  [ADDITIONAL_INFORMATION_CONSTANTS.FORM_NAME]:
    ADDITIONAL_INFORMATION_CONSTANTS.FORM_HEADER,
};

export enum FILE_ATTACHMENTS_CONSTANTS {
  FORM_NAME = "FileAttachments",
  FORM_HEADER = "File Attachments",
  FORM_DESCRIPTION = "Upload photos and documents related to your claim",

  // Extend base constants with string literals
  PHOTOS = "photoAttachments",
  DOCUMENTS = "documentAttachments",
}

export const FILE_ATTACHMENTS_FORM_NAME_TO_HEADER = {
  [FILE_ATTACHMENTS_CONSTANTS.FORM_NAME]:
    FILE_ATTACHMENTS_CONSTANTS.FORM_HEADER,
};

// IPL Third Party Administrators
export const IPL_TPA_SEDGWICK = "sedgwick";
export const IPL_TPA_ZURICH = "zurich";
